/* global axios */
import ApiClient from './ApiClient';

class BulkActionsAPI extends ApiClient {
  constructor() {
    super('bulk_actions', { accountScoped: true });
  }

  mark_as_read_all(payload) {
    return axios.post(`${this.url}/mark_as_read_all`, payload);
  }
}

export default new BulkActionsAPI();
